<template>
    <HelpCenterLayout v-bind="helpCenterSharedData.getHelpCenterLayoutProps()">
        <template #hero>
            <HelpCenterSearchHero />
        </template>

        <HomeSectionContainer class="px-6 py-16">
            <div class="space-y-4">
                <div class="px-2">
                    <div class="text-3xl font-semibold">
                        {{ category.title }}
                    </div>
                    <div class="font-light">
                        {{ category.description }}
                    </div>
                    <div class="mt-4 text-sm text-gray-500">
                        {{ category.getArticleCount() }} articles
                    </div>
                </div>
                <div class="space-y-4">
                    <div
                        v-for="subcategory in category.subcategories"
                        :key="subcategory.slug"
                        :id="subcategory.slug"
                        class="p-6 rounded-lg bg-white border border-stone-200 space-y-4"
                    >
                        <div class="mb-4">
                            <div class="text-lg font-semibold">
                                {{ subcategory.title }}
                            </div>
                            <div class="font-light text-gray-600">
                                {{ subcategory.description }}
                            </div>
                        </div>

                        <div class="border-b border-b-gray-200"></div>

                        <div>
                            <a
                                v-for="article in subcategory.articles"
                                :key="article.slug"
                                :href="article.url"
                                class="p-4 bg-white hover:bg-stone-100 transition ease-linear rounded-xl block"
                            >
                                <div
                                    class="flex items-center justify-between gap-2"
                                >
                                    <div class="space-y-4 text-gray-800">
                                        <div class="space-y-0">
                                            <div class="font-medium">
                                                {{ article.title }}
                                            </div>
                                            <div
                                                class="font-light text-gray-600 text-wrap"
                                            >
                                                {{ article.excerpt }}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <Icon
                                            name="angle-right"
                                            class="w-3 h-3"
                                        />
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </HomeSectionContainer>
    </HelpCenterLayout>
</template>

<script setup lang="ts">
    import HelpCenterSearchHero from '@/HelpCenter/Component/HelpCenterSearchHero.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import CMSCategory from '@/CMS/Content/Entity/CMSCategory'
    import HelpCenterSharedData from '@/HelpCenter/Entity/HelpCenterSharedData'
    import HomeSectionContainer from '@/HelpCenter/Component/HomeSectionContainer.vue'
    import HelpCenterLayout from '@/HelpCenter/Shared/HelpCenterLayout.vue'
    import type {
        CMSCategoryRawData,
        HelpCenterSharedDataRawData,
    } from '@/Shared/AutoGenerated/Main'

    interface HelpCenterIndexArticlesProps {
        helpCenterSharedDataRawData: HelpCenterSharedDataRawData
        categoryRawData: CMSCategoryRawData
    }

    const props = defineProps<HelpCenterIndexArticlesProps>()

    const helpCenterSharedData = HelpCenterSharedData.hydrate(
        props.helpCenterSharedDataRawData,
    )
    const category = CMSCategory.hydrateSingle(props.categoryRawData)
</script>
